import React from 'react';
import BookingPageTab from './settings/BookingPageTab.jsx';
import TopBar from '../components/TopBar.jsx';

export default function BookingPage() {
  return (
    <div className="space-y-4 max-w-[1400px] mx-auto pb-12">
      <TopBar
        title="Appointment Booking Page"
        subtitle="Account Settings · Personal Calendar & Public Self-Booking Link"
      />
      <BookingPageTab />
    </div>
  );
}
